export const personal_info = {
    name: 'Jeff Hwang',
    roles: [
        'Software Developer',
        'Frontend Developer',
        'Full-Stack Developer',
        'Software Engineer',
    ],
    github: 'https://github.com/jhwa426',
    cv: 'https://drive.google.com/file/d/1EOfcupxyTn2krgEauEBoNx4yhi4zvPip/view?usp=drive_link',
    linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
    instagram: 'https://www.instagram.com/jeff_hjy/',
    facebook: 'https://www.facebook.com/wodud6359',
};

export const experiences = [
    {
        id: 0,
        img: './assets/phq-akl.webp',
        companyName: 'PHQ Auckland, New Zealand',
        companyLink: 'https://phq.nz/',
        role: 'Junior Frontend Developer',
        desc: [
            'Collaborating with cross-functional teams to deliver a high-quality Google project built with AngularJS',
            'Assisting in developing responsive and interactive user interfaces, ensuring seamless backend API integration and strict adherence to design specifications',
        ],
        date: 'Nov 2024 – Present',
    },
    {
        id: 1,
        img: './assets/Emnet.webp',
        companyName: 'EMNET, South Korea',
        companyLink: 'https://en.emnet.co.kr/',
        role: 'Software Engineer Intern',
        desc: [
            'Collaborated closely with account executives at an online advertising agency to conceptualise and develop an internal tool for real-time analysis of daily data trends in advertisements using web crawling techniques',
            'Enhanced web development and database management proficiency by crafting an internal tool and augmenting full-stack logic by integrating auxiliary functions for front-end and back-end systems',
            'Acquired valuable professional experience through active participation in a high-paced team environment, applying Agile Methodology to adapt quickly to project dynamics',
            'Skills gained: C# (OOP), ASP.NET, WinForms, MSSQL server, RESTful APIs, Postman API Testing, Fiddler, Data Analysis, Agile Methodologies',
        ],
        date: 'Jan 2023 – Jun 2023',
    },
];

export const skills = [
    {
        title: 'Frontend',
        skills: [
            {
                name: 'Angular JS',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg',
            },
            {
                name: 'React JS',
                image: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K',
            },
            {
                name: 'Redux',
                image: 'https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg',
            },
            {
                name: 'Next JS',
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=',
            },
            {
                name: 'TypeScript',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg',
            },
            {
                name: 'JavaScript',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg',
            },
            {
                name: 'Sass',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg',
            },
            {
                name: 'Tailwind CSS',
                image: 'https://cdn.svgporn.com/logos/tailwindcss-icon.svg',
            },
            {
                name: 'Styled-Components',
                image: './assets/Styled-Components.webp',
            },
            {
                name: 'Material UI',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg',
            },
        ],
    },
    {
        title: 'Backend & Database',
        skills: [
            {
                name: 'Node JS',
                image: 'https://nodejs.org/static/images/logo.svg',
            },
            {
                name: 'Express JS',
                image: './assets/express-js.webp',
            },
            {
                name: 'MongoDB',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg',
            },
            {
                name: 'MSSQL',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/microsoftsqlserver/microsoftsqlserver-original.svg',
            },
            {
                name: 'SQLite',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/sqlite/sqlite-original.svg',
            },
        ],
    },
    {
        title: 'Object-Oriented Programming',
        skills: [
            {
                name: 'Java',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg',
            },
            {
                name: 'C#',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg',
            },
            {
                name: '.NET',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg',
            },
            {
                name: 'RESTful APIs',
                image: './assets/REST API.webp',
            },
            {
                name: 'Agile Methodology',
                image: 'https://cdn.worldvectorlogo.com/logos/agile-software.svg',
            },
        ],
    },
    {
        title: 'Data Science & Tools',
        skills: [
            {
                name: 'Python',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg',
            },
            {
                name: 'Pandas',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original.svg',
            },
            {
                name: 'NumPy',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg',
            },
            {
                name: 'R',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/r/r-original.svg',
            },
            {
                name: 'Tableau',
                image: 'https://cdn.worldvectorlogo.com/logos/tableau-software.svg',
            },
            {
                name: 'Git',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg',
            },
            {
                name: 'GitHub',
                image: 'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
            },
            {
                name: 'Netlify',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/netlify/netlify-original.svg',
            },
            {
                name: 'Render',
                image: 'https://media.licdn.com/dms/image/D4E0BAQGGDoFoqHtOvA/company-logo_200_200/0/1702595267620/renderco_logo?e=2147483647&v=beta&t=Ywm0UZpTXbiXPopyfCDty8QXSEVz88QWWCwy28qLUyE',
            },
            {
                name: 'Vercel',
                image: 'https://cdn.svgporn.com/logos/vercel-icon.svg',
            },
            {
                name: 'VS Code',
                image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.webp?20210804221519',
            },
            {
                name: 'Postman',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/postman/postman-original.svg',
            },
            {
                name: 'Figma',
                image: './assets/figma.webp',
            },
            {
                name: 'Jira',
                image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/jira/jira-original.svg',
            },
        ],
    },
];

export const projects = [
    {
        id: 0,
        title: 'Patient-Management-System',
        date: 'Aug 2024 - Sep 2024',
        description: 'Healthcare Platform - CarePulse',
        descriptionDetails: [
            'Built a healthcare management platform that streamlines patient registration, appointment scheduling, and medical records, as well as implemented complex forms and SMS notifications',
            'Register as a Patient: Users can sign up and create a personal profile as a patient',
            'Book a New Appointment with Doctor: Patients can schedule appointments with doctors at their convenience and can book multiple appointments',
            'Manage Appointments on Admin Side (Admin Passkey : 123123): Administrators can efficiently view and handle all scheduled appointments',
            'Confirm/Schedule Appointment from Admin Side: Admins can confirm and set appointment times to ensure they are properly scheduled',
            'Cancel Appointment from Admin Side: Administrators have the ability to cancel any appointment as needed',
            'Send SMS on Appointment Confirmation: Patients receive SMS notifications to confirm their appointment details',
            'Complete Responsiveness: The application works seamlessly on all device types and screen sizes',
            'File Upload Using Appwrite Storage: Users can upload and store files securely within the app using Appwrite storage services',
            'Manage and Track Application Performance Using Sentry: The application uses Sentry to monitor and track its performance and detect any errors',
        ],
        img: './assets/carepulse.webp',
        skills: [
            'React JS',
            'TypeScript',
            'Tailwind CSS',
            'Appwrite',
            'ShadCn',
            'Sentry',
            'Twilio',
        ],
        category: 'web development',
        github: 'https://github.com/jhwa426/Patient-Management-System',
        website: 'https://patient-management-system-carepulse.vercel.app/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
        ],
    },

    {
        id: 1,
        title: 'Full-Stack Football Booking Management System',
        date: 'June 2024 - Aug 2024',
        description: 'MERN project - Booking.Fooball',
        descriptionDetails: [
            'Developed a Full-Stack Football Booking Management System utilising React JS and the MERN (MongoDB, Express, React, and Node) stack',
            'Feel free to explore the website as an administrator (email: admin@a.com, password: admin)',
            'As an admin, admin’ll have access to the Administration Panel, where you can manage current bookings, courts, and user accounts',
            'Implemented a persistent storage application for CRUD on the website (Create the court, Read the current booking, Update the court and Delete the court) through a RESTful API',
            'Facilitated the development of React applications with backend connectivity via HTTP and incorporated user authentication',
            'Payment Methods API (stripe JS)',
            'Implemented routing & route-related data fetching with React Router',
            'UI development (React Bootstrap, React Spinners, SweetAlert2)',
            'Deployment of the website by Render.com for both Frontend and Backend',
        ],
        img: './assets/football.booking.webp',
        skills: [
            'React JS',
            'MongoDB',
            'NodeJS/ExpressJS',
            'HTML5/CSS3/JavaScript',
            'RESTful APIs',
        ],
        category: 'web development',
        github: 'https://github.com/jhwa426/Booking-System',
        website: 'https://booking-football.onrender.com/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
        ],
    },

    {
        id: 2,
        title: 'React-Portfolio',
        date: 'Jul 2023 - Nov 2023',
        description: 'React JS - Personal Portfolio Website main',
        descriptionDetails: [
            'How to implement font icons in React',
            'How to create Styled-components',
            'Move faster with intuitive React UI tools',
            'MUI libraries offer a comprehensive suite of free UI tools to help you ship new features faster.',
            'How to create and implement a contact form in React using EmailJS',
            'Theme customisation button features (Dark / Light)',
            'Responsive navigation bar',
            'Framer Motion animation library for the project card',
        ],
        img: './assets/personal website3.webp',
        skills: [
            'React JS',
            'React Router',
            'Styled-Components',
            'MUI libraries',
            'HTML5/CSS3/JavaScript',
            'APIs',
        ],
        category: 'web development',
        github: 'https://github.com/jhwa426/React-Portfolio/tree/main/React-JS-Personal-Portfolio-Website-ver3/personal-website',
        website: 'https://jeff-hwang.netlify.app/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
        ],
    },

    {
        id: 3,
        title: 'Udemy Bootcamp-React The complete guide 2023 - 2024',
        date: 'Jul 2023 - Jan 2024',
        description: 'React Component, React Router & Redux',
        descriptionDetails: [
            'Acquired proficiency in React, Hooks, Redux, React Router, and Next.js',
            'Managed complex state efficiently with React’s Context API & React Redux',
            'Gained knowledge about routing & route-related data fetching with React Router',
            'Built Full-Stack React apps with NextJS',
            'Developed multiple demo projects & explored realistic examples',
            'Learned all about React Hooks and React Components',
            'Constructed standalone React apps & applications connected to a backend via HTTP',
            'Implemented user authentication in React apps',
            'Initiated React Unit Testing',
        ],
        img: './assets/react-the-complete-guide-2023.webp',
        skills: [
            'React JS',
            'React Hooks/Router',
            'Redux',
            'NEXT JS',
            'HTML5',
            'CSS3',
            'JavaScript',
        ],
        category: 'bootcamp',
        github: 'https://github.com/jhwa426/React-The-Complete-Guide-2023',
        website:
            'https://www.udemy.com/course/react-the-complete-guide-incl-redux/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'Udemy',
                img: './assets/udemy.webp',
                github: 'https://github.com/jhwa426/React-The-Complete-Guide-2024',
                linkedin:
                    'https://www.udemy.com/course/react-the-complete-guide-incl-redux/',
            },
        ],
    },

    {
        id: 4,
        title: 'Udemy Bootcamp-Web Development',
        date: 'Jan 2023 - July 2023',
        description: 'Become a Full-Stack Web Developer',
        descriptionDetails: [
            'Completed an intensive Full-stack Web Development course, gaining proficiency in HTML/CSS/JavaScript/jQuery, NodeJS/ExpressJS, MongoDB, and ReactJS, and successfully built 16 web development projects',
        ],
        img: './assets/bootcamp-web development.webp',
        skills: [
            'HTML5',
            'CSS3',
            'JavaScript',
            'React JS',
            'MongoDB',
            'Node JS',
            'Express JS',
            'Git',
        ],
        category: 'bootcamp',
        github: 'https://github.com/jhwa426/Bootcamp-Web_Development',
        website:
            'https://www.appbrewery.co/p/web-development-course-resources/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'Udemy',
                img: './assets/udemy.webp',
                github: 'https://github.com/londonappbrewery',
                linkedin:
                    'https://www.udemy.com/course/the-complete-web-development-bootcamp/',
            },
        ],
    },

    {
        id: 5,
        title: 'React-Portfolio',
        date: 'Jul 2023 - Nov 2023',
        description: 'React JS - Personal Portfolio Website ver 4',
        descriptionDetails: [
            'Implemented the React Icons library in various React projects',
            'Utilised React useState hooks for state management',
            'Developed modern website designs using CSS3.',
            'Enhanced development speed with intuitive React UI tools',
            'Leveraged MUI libraries to access a comprehensive suite of free UI tools for faster feature deployment',
            'Added multiple contact options on the website, including WhatsApp and Facebook Messenger',
            'Created and implemented a contact form in React using EmailJS',
        ],
        img: './assets/personal website4.webp',
        skills: [
            'React JS',
            'React Router',
            'NEXT JS',
            'MUI libraries',
            'HTML5',
            'CSS3',
            'JavaScript',
        ],
        category: 'web development',
        github: 'https://github.com/jhwa426/React-Portfolio/tree/main/React-JS-Personal-Portfolio-Website-ver4/personal-website',
        website: 'https://jeff-hwang4.netlify.app/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
        ],
    },

    {
        id: 6,
        title: 'React-Portfolio',
        date: 'Jul 2023 - Nov 2023',
        description: 'React JS - Personal Portfolio Website ver 2',
        descriptionDetails: [
            'Implemented SVG animations using GSAP and React',
            'Integrated font icons in React',
            'Developed and integrated a contact form in React using EmailJS',
        ],
        img: './assets/personal website2.webp',
        skills: [
            'React JS',
            'React Router',
            'Redux',
            'NEXT JS',
            'HTML5',
            'CSS3',
            'JavaScript',
        ],
        category: 'web development',
        github: 'https://github.com/jhwa426/React-Portfolio/tree/main/React-JS-Personal-Portfolio-Website-ver2/personal-website',
        website: 'https://jeff-hwang2.netlify.app/',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
        ],
    },

    {
        id: 7,
        title: 'React-Portfolio',
        date: 'Jul 2023 - Nov 2023',
        description: 'React JS - Personal Portfolio Website ver 1',
        descriptionDetails: [
            'Implemented SVG animation using GSAP and React',
            'Animated letters on hover using Animate.css and React',
            'Added page loading animation using React-Loaders',
            'Integrated Pacman animation in React',
            'Created custom 3D CSS animations',
            'Implemented font icons in React',
            'Developed and integrated a contact form in React using EmailJS',
            'Added maps to the website in React using Leaflet.js',
        ],
        img: './assets/personal website1.webp',
        skills: [
            'React JS',
            'React Router',
            'Redux',
            'NEXT JS',
            'HTML5',
            'CSS3',
            'JavaScript',
        ],
        category: 'web development',
        github: 'https://github.com/jhwa426/React-Portfolio/tree/main/React-JS-Personal-Portfolio-Website-ver1/website',
        website:
            'https://github.com/jhwa426/React-Portfolio/tree/main/React-JS-Personal-Portfolio-Website-ver1/website',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
        ],
    },

    {
        id: 8,
        title: 'Data Analysis',
        date: 'Jul 2022 - Nov 2022',
        description: 'Big Data, Data Mining / Machine Learning techniques',
        descriptionDetails: [
            'The purpose of this course is to acquire knowledge to apply appropriate Big Data, Data Mining / Machine Learning techniques to gain information insights to various problems faced by an organisation. The focus of this course is to firstly identify a problem from a given case study that needs solving; secondly, consider various possible designs and select the most appropriate solution; and finally, to specify a solid plan for building and evaluating the system designed. No executable implementation of the system is expected. A basic knowledge of Big Data and tools will be given. Knowledge and experience of state of the art machine learning tools from a key vendor, will be gained in the labs with opportunities and encouragement to explore other tools.',
        ],
        img: './assets/uoa.webp',
        skills: [
            'Python',
            'Pandas',
            'NumPy',
            'Plotly',
            'Matplotlib',
            'GoogleColab',
        ],
        category: 'data science',
        github: 'https://github.com/jhwa426/Big-Data-and-Machine-Learning',
        website:
            'https://colab.research.google.com/drive/1fVpyzKzi1Gp6nageB4kf9VTYVqRRc6iV?usp=sharing', //google colab link connect later!
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'UoA',
                img: './assets/uoa.webp',
                github: 'https://github.com/jhwa426/Big-Data-and-Machine-Learning',
                linkedin: 'https://www.auckland.ac.nz/en.html',
            },
        ],
    },

    {
        id: 9,
        title: 'Object Oriented Software Development',
        date: 'Jul 2021 - Nov 2021',
        description:
            'Java programming language, GUI programming and application-level multi-threading',
        descriptionDetails: [
            'Using Java programming language, we demonstrate fundamental skills in object-oriented software development, GUI programming and application-level multi-threading.',
            'An introduction to object-oriented paradigm of designing and developing software applications. The focus of this course would be on learning good software design objectives and principles. Using Java programming language, students will learn modelling and developing software applications of reasonable complexity and quality through the application of established object-oriented design principles and patterns. In doing so, students will also demonstrate fundamental skills in object-oriented software development, GUI programming and application-level multi-threading. This course is one of the prerequisites for the third year courses of COMPSCI 331, COMPSCI 335, COMPSCI 340, COMPSCI 345 and COMPSCI 373. The skills developed in this course are particularly useful for those wishing to have a career in professional software development. Students planning to take the capstone course next year are also expected to benefit from the learning outcomes of this course.',
        ],
        img: './assets/uoa.webp',
        skills: ['JAVA', 'Eclipse', 'Multi-threading'],
        category: 'object oriented program',
        github: 'https://github.com/jhwa426/Java',
        website: 'https://github.com/jhwa426/Java',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'UoA',
                img: './assets/uoa.webp',
                github: 'https://github.com/jhwa426/Java',
                linkedin: 'https://www.auckland.ac.nz/en.html',
            },
        ],
    },

    {
        id: 10,
        title: 'Database',
        date: 'Mar 2021 - Jul 2023',
        description: 'SQL, MSSQL, MongoDB Database',
        descriptionDetails: [
            'BUSAN 201: This course aims to expose you to knowledge, tools, and methods necessary to effectively manage data in today’s digital world by allowing you to work with real data in various formats, use industry-relevant software, practise and develop problem-solving techniques, and develop an appreciation of data as a valuable asset for any business in any industry.',
            'INFOSYS 222: This course aims to develop the fundamental skills of designing and developing a relational database. All assessments require student to demonstrate their mastery of the practical aspects of the course including data modelling and structured query language (SQL)',
            'BUSAN 300: This course aims to provide you with a data management toolbox that is applicable to business data among disciplines and industries; to develop your skills in analytical thinking, programmatic problem solving, and business communication; to build up your proficiency in making raw data valuable and meaningful for a business audience; and to expose you to the digital data life-cycle.',
        ],
        img: './assets/uoa.webp',
        skills: ['MSSQL', 'SQLite', 'Mongo DB'],
        category: 'data science',
        github: 'https://github.com/jhwa426/Database',
        website: 'https://github.com/jhwa426/Database',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'UoA',
                img: './assets/uoa.webp',
                github: 'https://github.com/jhwa426/Database',
                linkedin: 'https://www.auckland.ac.nz/en.html',
            },
        ],
    },

    {
        id: 11,
        title: 'Data Technologies',
        date: 'Mar 2022 - Jul 2022',
        description: 'R programming language at The University of Auckland',
        descriptionDetails: [
            'Explores the processes of data acquisition, data storage and data processing using current computer technologies. Students will gain experience with and understanding of the processes of data acquisition, storage, retrieval, manipulation, and management. Students will also gain experience with and understanding of the computer technologies that perform these processes.',
            'This course introduces R programming to handle a wide variety of data science challenges, from importing, wrangling, visualising data, to reproducible reporting, for effective data-driven decision making. Students will gain an understanding of tidy data principles, grammar of data manipulation, and grammar of graphics, using a set of data-oriented tools. Students will also learn to solve data-analytical problems in both business and research environments.',
        ],
        img: './assets/uoa.webp',
        skills: ['R for Statistical Computing', 'SQLite'],
        category: 'data science',
        github: 'https://github.com/jhwa426/STATS-220',
        website: 'https://github.com/jhwa426/STATS-220',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'UoA',
                img: './assets/uoa.webp',
                github: 'https://github.com/jhwa426/STATS-220',
                linkedin: 'https://www.auckland.ac.nz/en.html',
            },
        ],
    },

    {
        id: 12,
        title: 'Python',
        date: 'Mar 2020 - Nov 2020',
        description: 'Python programming language, Data Structures, Algorithms',
        descriptionDetails: [
            'COMPSCI 101: This course introduces computer programming using the Python programming language. The main focus is on learning to understand the detailed requirements of a programming task, and writing programs that are well structured, correct and easy to read. The course covers simple variables, expressions, input and output, control structures, functions, using standard data structures such as lists and dictionaries, and using standard Python modules. The course is designed for students who do not have any prior programming experience. For students who wish to continue with Computer Science, this course will prepare them for the core Stage I paper COMPSCI 130.',
            'COMPSCI 130: This is the entry course to Computer Science for students with prior programming experience. It focuses on the quality of processes used when developing software, and the quality of the software product produced using those processes. The course provides an introduction to fundamental software development techniques and processes, such as reading, writing, and documenting programming code, decomposing problems, testing, debugging, using recursion and handling unexpected errors. It also addresses efficient ways to organize and manipulate data, including sorting and searching algorithms, and writing software that uses and implements common abstract data types such as lists, stacks, queues, dictionaries and trees. The course will be taught using the Python programming language.',
        ],
        img: './assets/uoa.webp',
        skills: ['Python', 'Data Structures', 'Algorithms', 'GUI programming'],
        category: 'data science',
        github: 'https://github.com/jhwa426/Python',
        website: 'https://github.com/jhwa426/Python',
        members: [
            {
                name: 'Jeff Hwang',
                img: './assets/jeff.webp',
                github: 'https://github.com/jhwa426',
                linkedin: 'https://www.linkedin.com/in/jeffhwa411/',
            },
            {
                name: 'UoA',
                img: './assets/uoa.webp',
                github: 'https://github.com/jhwa426/Python',
                linkedin: 'https://www.auckland.ac.nz/en.html',
            },
        ],
    },
];

export const educations = [
    {
        id: 0,
        img: './assets/uoa.webp',
        desc: 'Big Data and Machine Learning, Database Systems, Data Analysis, Management, and Visualisation, Exploratory data Analysis, Capstone Project',
        school: 'The University of Auckland, New Zealand',
        schoolLink:
            'https://www.auckland.ac.nz/en/study/study-options/find-a-study-option/information-technology-management/undergraduate/bsc-info-management-from-2019.html',
        degree: 'Bachelor of Science Major in Information and Technology Management',
        date: 'Mar 2020 – Nov 2023',
    },
    {
        id: 1,
        img: './assets/uoa.webp',
        desc: 'Object Oriented Software Development, Agile Methodology, Computer Systems, Data Structures & Algorithms',
        school: 'The University of Auckland, New Zealand',
        schoolLink:
            'https://www.auckland.ac.nz/en/science/study-with-us/study-options/about-modules/software-development.html',
        degree: 'Bachelor of Science Software Development Module [COMPSCI 101, 130, 230, 235]',
        date: 'Mar 2020 – Nov 2023',
    },
    {
        id: 2,
        img: './assets/acg-logo.webp',
        desc: 'The University of Auckland Certificate in Foundation Studies',
        school: 'ACG International College, Auckland, New Zealand',
        schoolLink: 'https://www.internationalcollege.ac.nz/',
        degree: 'The University of Auckland Certificate in Foundation Studies',
        date: 'Jan 2019 – Dec 2019',
    },
];
